import { render } from "./SlickItem.vue?vue&type=template&id=581dd5ae&scoped=true"
import script from "./SlickItem.vue?vue&type=script&lang=js"
export * from "./SlickItem.vue?vue&type=script&lang=js"

import "./SlickItem.vue?vue&type=style&index=0&id=581dd5ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-581dd5ae"]])

export default __exports__